module.exports = __webpack_public_path__ + "static/media/left_forearm_extended.33eaeb27.png";